export default __webpack_public_path__ + "navigation-examples-route-alerts-960-78256ce9c3f63fbe4756c9487b721a0f.png";